import { useEffect } from "react";
import { useRelayEnvironment } from "react-relay";
import {
  GraphQLSubscriptionConfig,
  requestSubscription,
  OperationType,
} from "relay-runtime";

type Options = { skip: boolean };
export function useSubscriptionWithSkip<
  TSubscriptionPayload extends OperationType = OperationType,
>(
  config: GraphQLSubscriptionConfig<TSubscriptionPayload>,
  opts: Options = { skip: false }
): void {
  const environment = useRelayEnvironment();

  const skip = opts.skip;
  useEffect(() => {
    if (skip) {
      return;
    }
    const { dispose } = requestSubscription(environment, config);
    return dispose;
  }, [environment, config, skip]);
}
